import React from 'react';
import '../App.css';
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { userLogin } from '../features/auth/authActions'
import type { RootState, AppDispatch } from '../store'
import { frontendVersion } from "./Version"
import { getBackendVersion } from '../features/auth/authActions';

export type LoginPageProps = {
  intervalHandler: (command: string, gameId: string, inGame: boolean) => void
};

  const LoginPage: React.FC<LoginPageProps> = ({ intervalHandler }) => {
    
    const dispatch = useDispatch<AppDispatch>();
    const { register, handleSubmit } = useForm()
    const navigate = useNavigate()
    const { accessToken } = useSelector((state: RootState) => state.auth)
    let [errorMessage, setErrorMessage] = useState<string>('');
    let [showError, setShowError] = useState<string>('hide');
    let [loginLoader, setLoginLoader] = useState<string>('');
    let [backendVersion, setBackendVersion] = useState<string>('...')

    useEffect(() => {
      if (accessToken) {
        //navigate('/scenariocreator')
      }
      async function asyncCall() {
        let bVersion = await dispatch(getBackendVersion());
        setBackendVersion(bVersion.payload)
      }

      asyncCall();
      
    }, [navigate, accessToken, dispatch]) // eslint-disable-line react-hooks/exhaustive-deps

    const submitForm = async (data: any) => {
        setLoginLoader('login-loader')
        let loginResponse: any = await dispatch(userLogin(data))
        if (loginResponse.payload === undefined) {
          setErrorMessage('Login Failed')
          setShowError('show')
          setLoginLoader('')
        } else {
          if (loginResponse.error === undefined) {
            navigate('/player')
          } else {
            setErrorMessage(loginResponse.payload)
            setShowError('show')
            setLoginLoader('')
          }
        }
    }

    return (
      <div className="login-page">
        <header className="txp-sc-header">
            <img className="txp-sc-logo-icon" src="img/txp-build-logo.svg" alt="" />
            <div className="txp-sc-title">TXP</div>
        </header>
        <div className="login-page-content">
        <div className="login-title">Sign In</div>
        <form onSubmit={handleSubmit(submitForm)}>
            <div className='form-group'>
                <input
                    type='text'
                    placeholder='Sign In ID'
                    className='form-input'
                    {...register('userID')}
                    required
                />
            </div>
            <div className='form-group'>
                <input
                    type='password'
                    placeholder='Password'
                    className='form-input'
                    {...register('password')}
                    required
                />
            </div>
            <div className={`login-errors ${showError}`}>
              <div className="error-message">
                {errorMessage}
              </div>
            </div>
            <button type='submit' className='sign-in-btn'>
                <span className="sign-in-text">Sign In</span>
                <div className={`loader ${loginLoader}`}></div>
                <span className="sign-in-plus">+</span>
            </button>
            </form>
          <div className="version-text">Version {frontendVersion}{backendVersion !== frontendVersion && `:${backendVersion}` }</div>
        </div>
      </div>
    )
  
  }
export default LoginPage;